import React from 'react';

import incomeIconUrl from '@/assets/decline-ui/income-icon.clean.svg?url';
import externalObligationsIconUrl from '@/assets/decline-ui/external-obligations-icon.clean.svg?url';
import outstandingPaymentsIconUrl from '@/assets/decline-ui/outstanding-payments-icon.clean.svg?url';
import expensesIconUrl from '@/assets/decline-ui/expenses-icon.clean.svg?url';

const iconClassName = 'h-[34px] w-[34px] shrink-0';

function DeclineBreakdownIconImage({
  src,
  className = iconClassName,
}: {
  src: string;
  className?: string;
}): React.JSX.Element {
  return (
    <img
      src={src}
      alt=""
      aria-hidden
      className={className}
      draggable={false}
    />
  );
}

export function DeclineBreakdownIcon({
  type,
}: {
  type: string;
}): React.JSX.Element {
  switch (type) {
    case 'INCOME':
      return (
        <DeclineBreakdownIconImage
          src={incomeIconUrl}
          className="h-[39px] w-[35px] shrink-0"
        />
      );
    case 'EXTERNAL_OBLIGATIONS':
      return (
        <DeclineBreakdownIconImage
          src={externalObligationsIconUrl}
          className="h-[33px] w-[33px] shrink-0"
        />
      );
    case 'INTERNAL_OBLIGATIONS':
      return (
        <DeclineBreakdownIconImage
          src={outstandingPaymentsIconUrl}
          className="h-[36px] w-[33px] shrink-0"
        />
      );
    case 'EXPENSES':
      return <DeclineBreakdownIconImage src={expensesIconUrl} />;
    default:
      return <DeclineBreakdownIconImage src={incomeIconUrl} />;
  }
}
